//cdn.shopify.com/s/files/1/0525/0275/7553/collections/O1CN01K3EPQZ29iJ9GqSOEJ__2206504728101-0-lubanu-s.jpg_430x430q90.jpg?v=1608983741
import ReactDOM from 'react-dom'
import { Flex, Text } from 'rebass/styled-components'

export const fmtImageSize = (url, size = 80) => {
    if (!url) {
        return ''
    }
    const arrs = url.split('.')
    const last = arrs.length - 1
    return arrs.slice(0, last).join('.') + `_${size}x${size}.` + arrs[last]
}

export const storage = {
    getItem(key, value) {
        return JSON.parse(localStorage.getItem(key) || null)
    },
    setItem(key, value) {
        localStorage.setItem(key, JSON.stringify(value))
    },
}

const Test = ({ title }) => (
    <Flex
        css={{
            position: 'fixed',
            borderRadius: '10px',
            top: '50%',
            left: '50%',
            transform: 'translateX(-50%)',
        }}
        justifyContent="center"
        alignItems="center"
        py="5px"
        px="15px"
        bg="rgba(0,0,0,0.8)"
    >
        <Text color="#fff" fontSize="18px">
            {title}
        </Text>
    </Flex>
)
export const Toast = (title, ms) => {
    let div = document.createElement('div')
    document.body.appendChild(div)
    ReactDOM.render(<Test title={title} />, div)
    setTimeout(() => {
        document.body.removeChild(div)
    }, ms || 1000)
}
